import { DELI_ENV_BASE_URL } from '@api/client';
import * as dealService from '@api/deals';
import { ChipIconButton } from '@components/chip-icon-button';
import { getBadgeColor } from '@components/entity-search/columns';
import { useBoolean, vtrUrl } from '@lib/common';
import { EntityType } from '@lib/deals';
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Link, MenuItem, Select, Tooltip, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ColDef } from '@material-ui/data-grid';
import CheckCircleIcon from '@material-ui/icons/Check';
import LaunchIcon from '@material-ui/icons/Launch';
import { useSnackbar } from 'notistack';
import { ControlledAutoCompleteDesignationField, ControlledAutoCompleteField } from 'pages/deals/deal-form/deal-associated-person/AssociatedPersonDialogContent_v2';
import { useCallback, useEffect, useMemo, useState } from 'react';

const IDENTITY_FUNC: any = () => void 0;

const ToolTiped = props => {
  let value = props.value;
  return (
    <Tooltip title={value}>
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</span>
    </Tooltip>
  );
};

const SelectRow = ({
  row,
  serialize,
  entity = {}
}: {
  row: any;
  serialize?: (row: any) => { name: string; vtr_id: string; type: string };
  entity: any;
}) => {
  const selectRow = row.setPartialEntity || IDENTITY_FUNC;
  
  const isRowSelected = entity?.vtr_id === row?.vtr_id;
  const onClick = useCallback(() => selectRow(serialize ? serialize(row) : row), [selectRow]);
  return (
    <ChipIconButton
      size="small"
      icon={<CheckCircleIcon fontSize="inherit" />}
      clickable
      style={{margin:"0 15px 0 0"}}
      onClick={onClick}
      color={isRowSelected ? "secondary" : "primary"}
    />
  );
};

const serializePerson = row => ({
  name: row.name,
  vtr_id: row.vtr_id,
  meta: row,
  type: EntityType.person,
});

export const personColumns = (entity) : ColDef[] => [
  { field: 'name',
   headerName: 'Name',
   flex: 1/ 8, 
  },
  {
    flex: 1 / 8,
    field: 'company_name',
    headerName: 'Company',
    renderCell(props) {
      const defaultCompany = {
        "PersonCompanyRelation": "",
        "company_vtr_id": "",
        "designation": "",
        "name": "No Company",
        "order_id": 1,
        "person_vtr_id": ""
      };
      
      const [selectedIndex, setSelectedIndex] = useState(0);
      const [companyArray, setCompanyArray] = useState(props?.row?.companies_associated || []);

      const selectOption = (event) => {
        const index = event.target.value;
        setSelectedIndex(index);
        const selectedCompany = companyArray[index] || defaultCompany;
        props.row.selectedCompany = selectedCompany;
      }

      useEffect(() => {
        const companies = props?.row?.companies_associated || [];
        setCompanyArray([...companies, defaultCompany]);
      }, [props?.row?.companies_associated]);

      const selectedCompany = companyArray[selectedIndex] || defaultCompany;

      return (
        <>
        <Select
          labelId="entity-select-label"
          id="entity-select"
          value={selectedIndex}
          label={"select company"}
          onChange={selectOption}>
            {companyArray?.length > 0 && companyArray?.map((comp, index)=>{
            const currentlyWorking = comp?.currently_working ? <span style={{opacity:"0.6", fontSize:"14px"}}>{`(CW : ${comp?.currently_working})`}</span>:""; 
            return <MenuItem key={index} value={index}>{comp?.name + " "}{currentlyWorking}</MenuItem>
          })}
        </Select>
        </>
      );
    },
  },
  {
    flex: 0.5/ 8,
    field: 'content_count',
    headerName: 'Content Count',
  },
  {
    // flex: 1/ 8,
    field: 'deal_count',
    headerName: 'Deal Count',
    renderCell(props) {
      return props?.row?.vtr_id  && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {(
            <Tooltip title={`Deals: ${props?.row?.deal_count}`}>
              <Link
                href={`${window.location.origin}/deals/search/?filters[0].id=entity_id&filters[0].value.$eq=${props?.row?.vtr_id}`}
                target="_blank">
                <Typography color="primary" variant="h6">
                  {props?.row?.deal_count}
                </Typography>
              </Link>
            </Tooltip>
          )}
        </div>
      )
    }
  },
  {
    field: 'role_id',
    headerName: 'Known For',
  },
  {
    flex: 2 / 8,
    field: 'actions',
    headerName: 'Actions',
    renderCell(props) {
      const [eachAssociatedPersonEdit, setEachAssociatedPersonEdit] = useState(false);
      return (
        <>
          <SelectRow row={props.row} serialize={serializePerson} entity={entity}/>
          {/* {!props?.row?.isSeller && <CreateCompanyPersonRelation person={props?.row} eachAssociatedPersonEdit={eachAssociatedPersonEdit} setEachAssociatedPersonEdit={setEachAssociatedPersonEdit}/>} */}
          {props.row.imdb_id && (
            <Tooltip title="IMDB">
              <a target="_blank" style={{display:"flex"}} href={`https://www.imdb.com/name/${props.row.imdb_id}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden",  }} src="/images/imdb.png"/>
              </a>
            </Tooltip>
          )}
          {props.row.person_tmdb_id && (
            <Tooltip title="TMDB">
              <a target="_blank" style={{display:"flex"}} href={`https://www.themoviedb.org/person/${props.row.person_tmdb_id}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden",  }} src="/images/tmdb.jpeg"/>
              </a>
            </Tooltip>
          )}
          {props.row.hubspot_id && (
            <Tooltip title="Hubspot">
              <a target="_blank" style={{display:"flex"}} href={`https://app.hubspot.com/contacts/20258191/record/0-1/${props?.row?.hubspot_id}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden",  }} src="/images/HS_logo.jpeg"/>
              </a>
            </Tooltip>
          )}
          {props.row.linkedin_url && (
            <Tooltip title="Linkedin">
              <a target="_blank" style={{display:"flex"}} href={`${props?.row?.linkedin_url}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden",  }} src="/images/linkedin.png"/>
              </a>
            </Tooltip>
          )}
          {props.row.vtr_id && (
            <Tooltip title="Person Master">
            <a target="_blank" style={{display:"flex"}} href={`${DELI_ENV_BASE_URL}/person-management/edit/${props?.row?.vtr_id}`}>
              <img style={{height:"30px", width:"30px", borderRadius: "4px", overflow: "hidden",  }} src="/images/vitrina.png"/>
            </a>
          </Tooltip>
          )}
        </>
      );
    },
  },
];

const serializeCompany = row => ({
  name: row.name,
  vtr_id: row.vtr_id,
  meta: row,
  type: EntityType.company,
});

export const companyColumns = (entity) : ColDef[] => [
  {
    field: 'name',
    flex: 3 / 12,
    headerName: 'Name',
    description: 'The Name of the company.',
    renderCell: params => {
      const value = params.row.name;
      const company_color =
        params.row.company_active == 'Inactive' ||
        params.row.company_active == 'inactive' ||
        params.row.company_publish_ready == -1 ||
        params.row.company_types.some(type => type.id == '197')
          ? 'red'
          : 'black';
      const TooltipValue = (
        <div>
          Company Name : {value}
          <br />
          Company Former Name : {params.row.company_former_name}
          <br />
          Company Legal Name : {params.row.vtr_company_legal_name}
        </div>
      );
      return (
        <Tooltip title={TooltipValue}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', color: company_color }}>
            {value}
          </span>
        </Tooltip>
      );
    },
  },
  {
    field: 'company_aka',
    flex: 2 / 12,
    headerName: 'A.K.A',
    description: 'The AKA of the company.',
  },
  {
    flex: 2 / 12,
    field: 'country_names',
    headerName: 'Country',
    description: 'Countries can be multiple.',
    sortable: false,
  },
  {
    flex: 3 / 12,
    field: 'company_type',
    headerName: 'Type',
    sortable: false,
    description: 'The type of the company',
  },
  {
    field: 'other_office_locations',
    headerName: 'O. Offices',
    description: 'List of other offices',
    renderCell(props) {
      const val = useMemo(
        () =>
          ((props.value as string) || '')
            .split('|')
            .map(i =>
              i
                .split(',')
                .map(s => s.trim())
                .filter(s => s)
                .join(', ')
            )
            .map(s => s.trim())
            .filter(s => s)
            .join(' | '),
        [props.value]
      );
      return <ToolTiped {...props} value={val} />;
    },
  },
  {
    flex: 2 / 12,
    field: 'projects_count',
    headerName: 'Projects (#)',
  },
  {
    flex: 2 / 12,
    field: 'deals',
    headerName: 'Deals (#)',
  },
  {
    flex: 2 / 12,
    field: 'reputation',
    headerName: 'Reputation (#)',
     renderCell(props) {
              const badgeName = props?.row?.reputation_badge?.name || 'N/A';
              const badgeColor = getBadgeColor(badgeName);
              return (
                <Tooltip
                  title={
                    <>
                      Reputation Score: {props?.row?.reputation}
                      <br />
                      Range: {props?.row?.reputation_badge?.range?.replace('TO', ' – ')}
                    </>
                  }>
                  <Chip
                    label={badgeName}
                    size="small"
                    style={{
                      marginRight: 10,
                      backgroundColor: badgeColor,
                      color: '#fff',
                      fontWeight: 500,
                    }}
                  />
                </Tooltip>
              );
            },
  },
  {
    flex: 1.5 / 12,
    field: '',
    headerName: 'Actions',
    sortable: false,
    renderCell(props) {
      return (
        <>
          <ChipIconButton
            size="small"
            component={Link}
            color="secondary"
            target="_blank"
            style={{ marginRight: 2 }}
            href={vtrUrl(props.row.vtr_id, EntityType.company)}
            icon={<LaunchIcon fontSize="inherit" />}
            clickable
          />
          <SelectRow row={props.row} serialize={serializeCompany} entity={entity}/>
        </>
      );
    },
  },
];
const addTooltip = c => {
  if (!c.renderCell) {
    c.renderCell = ToolTiped;
  }
  return c;
};
export const contentToColumns= (custom) => ({
  [EntityType.company]: companyColumns(custom).map(addTooltip),
  [EntityType.person]: personColumns(custom).map(addTooltip)
});
